import { Checkbox as MantineCheckbox } from '@mantine/core'
import { colors } from 'settings/colors'

export const Checkbox = ({ checked, disabled }: { checked: boolean; disabled?: boolean }) => {
  return (
    <MantineCheckbox
      color="gray.0"
      checked={checked}
      disabled={!!disabled}
      styles={{
        root: { cursor: 'pointer' },
        body: { cursor: 'pointer' },
        labelWrapper: { cursor: 'pointer' },
        label: { color: '#ffffff', cursor: 'pointer' },
        input: {
          // TODO: colors after revamp
          backgroundColor: !!disabled ? 'rgba(112, 112, 112, 1)' : colors.white,
          border: 'none',
          cursor: 'pointer',
        },
      }}
      iconColor={colors.midnight}
      onChange={() => null}
    />
  )
}
